import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
function getCollapseUtilityClass(slot) {
  return generateUtilityClass("MuiCollapse", slot);
}
generateUtilityClasses("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
export {
  getCollapseUtilityClass
};
//# sourceMappingURL=collapseClasses.es.js.map
